<div class="content-modal-informativo">
  <div class="title-wrapper">
    <b>{{ data.title }}</b>
    <ion-icon
      *ngIf="data.closeButtonCallback"
      class="i-close"
      role="button"
      tabindex="0"
      aria-label="Cerrar"
      (click)="data.closeButtonCallback()"
      (keydown.enter)="data.closeButtonCallback()"
    ></ion-icon>
  </div>
  <div class="description-wrapper">
    <div>
      <ng-container *ngFor="let text of data.description">
        <p [innerHTML]="text"></p>
      </ng-container>
    </div>
  </div>
  <div class="action-wrapper">
    <button
      class="btn primary primary-button"
      (click)="data.primaryButtonCallback()"
    >
      {{ data.primaryButtonText }}
    </button>
  </div>
</div>
